import { createNode } from '@glueapp/graph-types';

export const If = createNode({
    id: 'If',
    name: 'If',
    description: 'A Node for conditionally selecting a value',
    aiDescription:
        'Selects one of two values based on a boolean condition.\n' +
        'Connect a boolean to "Condition", and values of any matching type to "If True" and "If False".\n' +
        'Outputs the chosen value on "Result". Both input branches use generic type T, so they must be the same type.',
    category: 'Flow Control',
    color: '#869094',
    integration: undefined,
    inPorts: {
        Condition: {
            kind: 'boolean',
        },
        'If True': {
            kind: 'generic',
            identifier: 'T',
        },
        'If False': {
            kind: 'generic',
            identifier: 'T',
        },
    },
    outPorts: {
        Result: {
            kind: 'generic',
            identifier: 'T',
        },
    },
    execute: function (input) {
        if (input.inPorts.Condition) {
            return { output: { Result: input.inPorts['If True'] } };
        } else {
            return { output: { Result: input.inPorts['If False'] } };
        }
    },
});
